module.exports = __webpack_public_path__ + "img/laravel-fullstack-app5.4e31483a.png";